<template>
  <span style="white-space: nowrap;" :class="{
    huaxian: data.isDel
  }">{{ isHide ? '***' : nowData }}</span>
</template>
<script lang="ts" setup>
const data = defineProps({
  value: {
    type: [String, Number],
    default: '',
  },
  showAll: {
    type: Boolean,
    default: true
  },
  // 是否删除金额
  isDel: {
    type: Boolean,
    default: false
  },
  // 是否隐藏价格
  isHide: {
    type: Boolean,
    default: false
  }
});
const nowData = computed(() => {

  if (data.showAll || data.value * 1 < 0.01) {
    // 去除末尾的 0
    let str = data.value * 1 + '';
    // 将字符串转为小数
    let floatNum = parseFloat(str);
    // 如果小数不存在或者为 NaN，返回原始数字


    if (isNaN(floatNum)) {
      return `￥${data.value}`
    }


    if (str.indexOf('.') !== -1) {
      // 获取小数点后的位数
      let decimalLength = str.length - str.indexOf('.') - 1;
      // 小数点后的位数大于6位则保留6位小数，去0
      if (decimalLength > 6) {
        str = (parseFloat(floatNum.toFixed(6)) * 1).toString();
      }
      // 如果小数点后的位数不足两位，补 0
      let paddedDecimal = decimalLength < 2 ? str.padEnd(str.length + 2 - decimalLength, '0') : str;
      // 将整数部分每隔三位添加逗号
      let [integerPart, decimalPart] = paddedDecimal.split('.');
      let formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 如果存在小数部分，拼接为新的格式化后的数字
      if (decimalPart) {
        return `￥${formattedIntegerPart}.${decimalPart}`;
      }
      // 否则返回只有整数部分的格式化后的数字
      return `￥${formattedIntegerPart}.00`;
    }
    else {

      return `￥${str.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.00`
    }
  }
  else {
    let chache = data.value * 1
    return chache.toLocaleString('zh-CN', {
      style: 'currency',
      currency: 'CNY',
    });
  }

});
</script>

<style scoped lang="scss" >
.huaxian {
  text-decoration: line-through;
}
</style>
